import { Tab, TabsContainer } from '../../utils/SubjectTabs';
import axios from 'axios';
import { useEffect, useState } from 'react';
import ScorePotentialChart from './charts/ScorePotentialChart';
import TableHeader from '../../components/generic/TableHeader';
import TestAnalysisLoader from '../../components/loaders/TestAnalysisLoader';

export default function ScorePotential({ packId, testId }) {
  const [scoreImprovement, setScoreImprovement] = useState(null);
  const [subjectMeta, setSubjectMeta] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubjectChange = (subject) => {
    setSelectedSubject(subject);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        const res = await axios.get(`/api/test/analysis/v2/${packId}/${testId}/errorAnalysis`);
        const scoreImprovementData = res?.data?.data?.scoreImprovement;
        setScoreImprovement(scoreImprovementData);
        const subjectMetaData = [];
        scoreImprovementData?.forEach((item) => {
          subjectMetaData.push(item.subjectMeta);
        });
        setSubjectMeta(subjectMetaData);
        setSelectedSubject(subjectMetaData[0]);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
    if (!scoreImprovement) {
      fetchData();
    }
  }, [packId, testId]);

  if (isLoading) return <TestAnalysisLoader />;

  return (
    <TableHeader headerTitle={'Score Potential'} headerTitleClass={'border-b-0'}>
      <div className="text-[var(--q3-neutral-default)] text-lg font-bold border border-y-0 border-[var(--q3-stroke-light)] rounded-none">
        {subjectMeta && subjectMeta?.length > 2 && (
          <div className="w-full overflow-x-auto">
            <TabsContainer color={selectedSubject?.color}>
              {subjectMeta?.map((tab) => (
                <Tab
                  key={tab._id}
                  isActive={selectedSubject?.title === tab.title}
                  color={selectedSubject?.title === tab.title ? selectedSubject?.color : 'var(--q3-neutral-light)'}
                  tabColor={tab.color}
                  bgColor="var(--q3-surface-dim)"
                  onClick={() => handleSubjectChange(tab)}
                >
                  {tab.icon && <img src={tab.icon} alt={tab.title} className="" />}
                  <p className="mb-0">{tab.title}</p>
                </Tab>
              ))}
            </TabsContainer>
          </div>
        )}
        <div className="flex flex-row bg-[var(--q3-surface-dim)] gap-6 py-4 px-6">
          <div className="flex flex-row items-center gap-2">
            <div className="w-4 h-4 bg-[var(--q3-accent-normal)] rounded-full" />
            <p className="text-[var(--q3-neutral-default)] text-sm font-medium">Actual Score</p>
          </div>
          <div className="flex flex-row items-center gap-2">
            <div
              className="w-4 h-4 rounded-full"
              style={{
                background: `linear-gradient(to top, var(--q3-surface-default), var(--q3-surface-glass-normal)), var(--q3-accent-normal)`,
              }}
            />

            <p className="text-[var(--q3-neutral-default)] text-sm font-medium">Improved score by error reduction</p>
          </div>
        </div>
      </div>
      <ScorePotentialChart selectedSubject={selectedSubject?._id} scoreImprovement={scoreImprovement} />
    </TableHeader>
  );
}
